// SidebarOption.js
import React from "react";
import { Link } from "react-router-dom";
import { ReactComponent as ARROW_DOWN } from "../../../assets/images/Arrow-Down.svg";
import { ReactComponent as ARROW_UP } from "../../../assets/images/Arrow-Up.svg";
import { DropdownBtn } from "../../Common/Buttons/DropdownBtn";

const SidebarOption = ({
  icon: Icon,
  text,
  number,
  count,
  hasDropdown = false,
  isOpenedDropdown = false,
  onClickDropdown,
  isActive,
  onClick,
  sidebarUrl,
  isBiggerOption = false,
  isAction = false,
  disabled = false,
  isLaunching = false,
}) => {
  const handleDropdownClick = (e) => {
    e.preventDefault(); // Prevent the default behavior of the Link
    e.stopPropagation(); // Stop event propagation to prevent triggering onClick
    onClickDropdown();
  };
  const handleOptionClick = (event) => {
    if (disabled || isLaunching) {
      event.preventDefault();
      return;
    }

    onClick?.(event);
  };
  const inactiveOptionStyle =
    isBiggerOption && !isActive ? { color: "#fff" } : undefined;

  const optionContent = (
    <div
      className={`option-sidebar ${isOpenedDropdown ? "opened-dropdown" : ""} ${
        isActive ? "option-active" : ""
      } ${disabled ? "option-disabled" : ""} ${
        isLaunching ? "option-loading" : ""
      }`}
      onClick={handleOptionClick}
    >
      {Icon && (
        <div
          style={inactiveOptionStyle}
          className={`icon-img ${isActive ? "activated" : ""}`}
        >
          <Icon />
        </div>
      )}
      <span
        style={inactiveOptionStyle}
        className={`info-text ${isActive ? "activated" : ""}`}
      >
        {isLaunching ? "실행 중" : text}
      </span>
      <div className="numbers-spacer">
        {number && (
          <span className={`info-number ${isActive ? "activated" : ""}`}>
            {number}
          </span>
        )}
        {count && (
          <span className={`count ${isActive ? "activated" : ""}`}>
            {count}
          </span>
        )}
      </div>

      {hasDropdown && (
        <div>
          <DropdownBtn onClick={handleDropdownClick}>
            {isOpenedDropdown ? <ARROW_UP /> : <ARROW_DOWN />}
          </DropdownBtn>
        </div>
      )}
    </div>
  );

  if (isAction) {
    return (
      <button className="sidebar-option-button" type="button">
        {optionContent}
      </button>
    );
  }

  return (
    <Link className="sidebar-option-link" to={sidebarUrl}>
      {optionContent}
    </Link>
  );
};

export default SidebarOption;
